module.exports = __webpack_public_path__ + "src/app/_content/imgs/endOfTerm/purchase_1.jpg?2c30528686a07a28d641307fdf250133";